export const BASE_URL = "BASE_URL";

export const LRR_API_KEY = "LRR_API_KEY";

export const USE_HTTPS = "USE_HTTPS";

export const USE_API_HISTORY = "USE_API_HISTORY";

export const NUM_ARCHIVES_PER_ROW = "NUM_ARCHIVES_PER_ROW";

export const NUM_ARCHIVES_TO_RENDER = "NUM_ARCHIVES_TO_RENDER";

export const DISPLAY_METHOD_WIDE_THUMBNAILS = "DISPLAY_METHOD_WIDE_THUMBNAILS";

export const DISPLAY_METHOD_IMAGES = "DISPLAY_METHOD_IMAGES";

export const SEARCH_STATS = "SEARCH_STATS";

export const USE_PAGINATED_SEARCH = "USE_PAGINATED_SEARCH";

export const SEARCH_STATS_DEFAULT = {
  filter: "",
  page: 1,
  sort: "date_added",
  direction: "desc",
  category: "",
};

export const SEARCH_HISTORY = "SEARCH_HISTORY";

export const ARCHIVE_HISTORY = "ARCHIVE_HISTORY";

export const RATING_TYPE = "RATING_TYPE";

export const NO_FUN_MODE_ENABLED = "NO_FUN_MODE_ENABLED";

export const IMAGE_SPACING_LEVEL = "IMAGE_SPACING_LEVEL";
